
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","x":"12","y":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.8 9.531V7.27c-1.156-.411-1.886-.527-2.253-1.414-.37-.89.07-1.494.593-2.595l-1.6-1.6c-1.093.52-1.703.963-2.595.593C10.056 1.885 9.94 1.15 9.53 0H7.27c-.408 1.144-.524 1.884-1.413 2.253h-.001c-.89.37-1.493-.068-2.595-.593l-1.6 1.6c.522 1.097.963 1.704.593 2.595C1.884 6.745 1.145 6.86 0 7.269V9.53c1.142.406 1.884.524 2.253 1.413.371.898-.08 1.517-.593 2.595l1.6 1.6c1.093-.52 1.704-.962 2.595-.592.89.368 1.006 1.105 1.414 2.253H9.53c.408-1.145.525-1.883 1.42-2.255.883-.367 1.484.07 2.588.595l1.6-1.6c-.52-1.094-.963-1.703-.594-2.594.37-.89 1.112-1.008 2.255-1.415zM8.4 11.2a2.8 2.8 0 110-5.6 2.8 2.8 0 010 5.6z"}})])
          )
        }
      }
    